// This file is duplicated from website_client.
// Universal Login may eventually be moved to the monorepo,
// in which case this could be deleted.

import React, { useMemo } from 'react'
import classNames from 'classnames'
import { Link as LinkType } from '../../../lib/types/link'
import style from './index.scss'
import LogoWithoutLink, {
  LogoType,
} from '../../../components/logo-without-link'
import { ReactComponent as ArrowLeft } from './arrow-left.inline.svg'

const TaskHeader: React.FC<{
  Link?: LinkType
  logoType?: LogoType
  title?: { label: string; url: string }
  back?: { label: string; handleClickBack: () => void }
  hairline?: boolean
}> = ({ Link, back, hairline = false }) => {
  const logo = useMemo(
    () => (
      <LogoWithoutLink
        type={'westfield-membership'}
        className={style.membershipLogo}
      />
    ),
    []
  )

  return (
    <div
      className={classNames(style['task-header'], {
        [style.hairline]: hairline,
      })}
    >
      <div className={style.wrapper}>
        <div className={style.header}>
          {back && (
            <button
              type="button"
              onClick={back.handleClickBack}
              className={style.backSection}
            >
              <ArrowLeft type="arrow-left" className={style.icon} />
            </button>
          )}
        </div>
        <div className={classNames(style.logoSection)}>
          {Link ? (
            <Link to="/" className={style.logoLink}>
              {logo}
            </Link>
          ) : (
            <div className={style.logoSection}>{logo}</div>
          )}
        </div>
        <div className={style.header}></div>
      </div>
    </div>
  )
}

export default TaskHeader
